import { proxy } from 'valtio'
import {
    EyeOutlined,
    LeftOutlined,
    HistoryOutlined,
} from '@ant-design/icons';

export const planDetailsState: any = proxy(
  {
    loading: false, // 加载状态
    informationLoading: false, // 信息分析loading
    analysisLoading: false, // 分析结果loading
    creativeProposalList: [], // 方案数据列表
    programmeTotal: 1, // 方案数据图片接口调用次数
    activeFrom: null, // 当前激活的方案
    activeIndex: 0, // 当前激活的创意方案索引
    generateImages: [], // 生成图片数据
    generateTotal: 1, // 生成图片 接口调用次数
    insertImage: [], // 插入图片数据
    seoText: '', // 方案SEO描述
    isInsertImage: false, // 是否插入图片
    insertImageOfficialAccount: null, // 插入图片公众号
    isOfficialAccountEdit: false, // 是否编辑公众号图片
    newFlag: false, // 是否为新方案
    historicalRecordsList: [], // 历史记录列表
    isHistoricalRecords: false, // 是否还原历史记录数据
    drawerDataIndex: 0, // 0:历史 1:预览
    calendarAnalysis: {
        advice: '',
        matching_degree: '',
        risk: '',
        relevance: '',
    },// 日历、热点分析数据
    productsId: '', // 产品ID
    brandName: '', // 品牌名称
    planDetailsData: {
        timerRef: null,
        ifCalendar: false,
    },
    drawerData: [
        { label: '历史', active: true, icon: <HistoryOutlined style={{ fontSize: '18px' }} className='card-outlined-icon' /> },
        { label: '预览', active: false, icon: <EyeOutlined style={{ fontSize: '18px' }} className='card-outlined-icon' /> },
    ],
    isSmartPush: false, // 是否智能推送
    overallSituationFrom: {}, // 全局 表单
    schemeState: null, // 方案状态
  }
)


export const codeEditorState: any = proxy(
  {
    expandText: '', // 扩写数据文本
    polishingText: '', // 润色文本
    seoOptimizationText: '', // 一键SEO描述文本
    isSeoOptimization: false, // 是否一键SEO优化
  }
)